<template>
    <div>
        <b-card
            class="mt-3"
            body-class="mt-3"
            >
            Path
            <b-form-input
                v-model="path"
                type="text"
                placeholder=""
                >
            </b-form-input>

            <div class="text-right mt-3">
                <button type="button" class="btn btn-theme" @click="onClickDownload">ダウンロード</button>
            </div>
        </b-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
//import GridPage from '@/components/GridPage.vue'
//import Item from '@/components/Item.vue'
//import ItemBadges from '@/components/ItemBadges.vue'
//import ItemThumb from '@/components/ItemThumb.vue'
//import UserSettingInfo from '@/components/UserSettingInfo.vue'
//import InsuranceTable from '@/components/InsuranceTable.vue'
//import UserProfileContent from '@/components/UserProfileContent.vue'

export default {
    components: {
//        GridPage,
//        Item,
//        ItemBadges,
//        ItemThumb,
//        UserSettingInfo,
//        InsuranceTable,
//        UserProfileContent,
    },
    props: {
//        user_uuid: {
//            type: String,
//            required: true,
//            default() {
//                return null
//            },
//        },
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'auth_email',
            'trans',
        ])
    },
    data() {
        return {
            path: '',
        }
    },
    watch: {
        $route: {
            async handler () {
                const path = this.$route.query['path']
                if (path) {
                    this.path = path
                    this.onClickDownload()
                }
            },
            immediate: true
        }
    },
    mounted() {
    },
    destroyed() {
    },
    methods: {
        async onClickDownload () {
            const response = await this.$store
                .dispatch('app/file', {
                    path: this.path,
                })
                .then((response) => {
                    try {
                        const url = new URL(response.data.url)
                        window.location.href = url
                        return true
                    } catch (e) {
                        throw e
                    }
                })
                .catch((error) => {
                })
        },
    },
}
</script>

